import {jsonToQueryString} from "./string";

// Get Consultants Route
export function getConsultantsOptionsRoute() {
    return `consultants-options`
}

// Candidate JobOrder Alert
export function getStoreCandidateJobOrderAlertRoute() {
    return `candidate_job_order_alert`
}

export function getCandidateJobOrderAlertsListRoute(candidateEmail, hash) {
    return `candidate_job_order_alert/${candidateEmail}?hash=${hash}`
}

// Covers routes
export function getConsultantCoverDraftFormRoute(id) {
    return `/myurban/consultants/cover/${id}/draft`
}

export function getConsultantCoverLightFormRoute(id) {
    return `/myurban/consultants/cover-light/${id}`
}

export function saveCoverRoute(id) {
    return `covers/${id}`
}
export function saveDraftCoverRoute(id) {
    return `covers/${id}/draft`
}
export function saveLightCoverRoute(id) {
    return `covers-light/${id}`
}

export function getAllClients() {
    return `all-clients`
}

export function getClientsWithoutCandidateAsTalent(params) {
    return `clients-without-candidate-as-talent${jsonToQueryString(params)}`
}

// JobSubmission routes
export function getApproveJobSubmissionCoverRoute(jobSubMissionId) {
    return `job_submissions/${jobSubMissionId}/approve`
}


// JobOrders routes
export function getReopenJobOrderRoute(id) {
    return `job_orders/${id}/reopen`
}
